import { render } from "./social_template.vue?vue&type=template&id=2fdff543&scoped=true"
import script from "./social_template.vue?vue&type=script&lang=js"
export * from "./social_template.vue?vue&type=script&lang=js"

import "./social_template.vue?vue&type=style&index=0&id=2fdff543&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fdff543"]])

export default __exports__